module.exports = {
  "country": "LU",
  "artist": "France Gall",
  "song": "Poupée de cire, poupée de son",
  "year": "1965",
  "place": "1",
  "spotify": "5kLCC1MMxOACV632KrSAS3"
};